export function getCGAlert(analysis: any): boolean {
  return ['warning', 'critical'].includes(analysis?.targetCG?.deviation?.status)
    || analysis?.validation?.lateralValidation?.isBalanced === false
}

export function getVerifiedTotalWeight(analysis: any) {
  const check = analysis?.validation?.totalWeightValidation
  // Historical exports used a regional default without identifying its source.
  if ((['vehicle_config', 'tare_plus_payload'].includes(check?.limitSource) ||
    String(check?.limitSource || '').startsWith('vehicle_mass_contract.')) && Number(check.maxWeight) > 0) return check
  const config = analysis?.input?.vehicleConfig
  if (analysis?.isCombined || config?.physicsType === 'tractor_semitrailer') return null
  const payloadValue = config?.capacity_weight ?? config?.loadSpace?.maxWeight ?? config?.loadSpace?.max_weight
  const payload = payloadValue == null || payloadValue === '' ? NaN : Number(payloadValue)
  const empty = analysis?.rawReactions?.emptyReactions
  const declaredTare = config?.empty_weight ?? config?.loadSpace?.emptyWeight
  const completeAxles = config?.axles?.length && config.axles.every((a: any) => a.emptyWeight != null && Number.isFinite(Number(a.emptyWeight)) && Number(a.emptyWeight) >= 0)
  const tare = declaredTare != null && declaredTare !== '' ? Number(declaredTare)
    : completeAxles && empty && Object.keys(empty).length && Object.values(empty).every(v => typeof v === 'number' && Number.isFinite(v) && v >= 0)
    ? Object.values(empty).reduce<number>((sum, v) => sum + Number(v), 0) : NaN
  if (!(payload > 0 && Number.isFinite(payload) && tare > 0 && Number.isFinite(tare))) return null
  const maxWeight = tare + payload
  return { maxWeight, emptyWeight: tare, payloadCapacity: payload, limitSource: 'tare_plus_payload',
    isCompliant: Number.isFinite(analysis?.totalVehicleWeight) ? analysis.totalVehicleWeight <= maxWeight : null }
}

export function getVehicleWarnings(result: any): any[] {
  const warnings: any[] = (result?.warnings || []).map((warning: any) => warning?.type === 'lateral_imbalance'
    ? { ...warning, message: 'Équilibre latéral : seuil de déséquilibre gauche/droite dépassé. Voir Centre de gravité.' }
    : warning).filter((warning: any) => warning?.type !== 'vehicle_weight_limit_unverified' || !getVerifiedTotalWeight(result?.advancedAxleAnalysis))
  const analysis = result?.advancedAxleAnalysis
  if (!analysis) return warnings
  const add = (warning: any) => {
    if (!warnings.some(w => w?.type === warning.type && w?.axleId === warning.axleId)
      && !(result?.violations || []).some((v: any) => v.type === warning.type && v.axleId === warning.axleId)) warnings.push(warning)
  }
  for (const issue of analysis.validation?.violations || []) {
    add(issue.type === 'lateral_imbalance' ? { ...issue,
      message: 'Équilibre latéral : seuil de déséquilibre gauche/droite dépassé. Voir Centre de gravité.' } : issue)
  }
  if (['warning', 'critical'].includes(analysis.targetCG?.deviation?.status)) add({
    type: 'cg_target_deviation', severity: 'warning',
    message: 'Centre de gravité : écart à la cible au-delà de la tolérance. Voir Centre de gravité.'
  })
  if (!getVerifiedTotalWeight(analysis)) add({
    type: 'vehicle_weight_limit_unverified', severity: 'warning',
    message: 'Limite de poids total véhicule non renseignée ou non traçable : contrôle non vérifié.'
  })
  const cargo = analysis.input?.loadingResult?.totalWeight
  const tare = analysis.rawReactions?.emptyReactions
  if (Number.isFinite(cargo) && tare && Object.values(tare).every(v => typeof v === 'number' && Number.isFinite(v))) {
    const expected = cargo + Object.values(tare).reduce<number>((sum, v) => sum + Number(v), 0)
    if (Number.isFinite(analysis.totalVehicleWeight) && Math.abs(expected - analysis.totalVehicleWeight) > 1) add({
      type: 'axle_mass_inconsistent', severity: 'high',
      message: `Charges d’essieux à recalculer : poids total enregistré ${analysis.totalVehicleWeight.toFixed(1)} kg, attendu ${expected.toFixed(1)} kg. Relancer l’optimisation.`
    })
  }
  return warnings
}
